// extracted by mini-css-extract-plugin
export default {"imgIconDiv":"imageUpload_imgIconDiv__0Tqu-","closeIcon":"imageUpload_closeIcon__Cl13-"};